<div class="use-list-container">
  <!-- 標題和過濾區域 -->
  <div class="use-list-header">
    <div class="title-section">
      <h2>化學品使用與庫存管理</h2>
      <div class="view-toggle">
        <button
          [class.active]="viewMode === 'department'"
          (click)="switchViewMode('department')"
        >
          <i class="fas fa-building"></i> 部門視圖
        </button>
        <button
          [class.active]="viewMode === 'chemical'"
          (click)="switchViewMode('chemical')"
        >
          <i class="fas fa-flask"></i> 化學品視圖
        </button>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-item">
          <label for="department-filter">部門</label>
          <select id="department-filter" [(ngModel)]="filterOptions.department">
            <option value="">全部部門</option>
            <option *ngFor="let dept of departments" [value]="dept.id">
              {{ dept.name }}
            </option>
          </select>
        </div>
        <div class="filter-item">
          <label for="chemical-filter">化學品</label>
          <select id="chemical-filter" [(ngModel)]="filterOptions.chemical">
            <option value="">全部化學品</option>
            <option *ngFor="let chem of chemicals" [value]="chem.id">
              {{ chem.chineseName }} ({{ chem.partNumber }})
            </option>
          </select>
        </div>
        <div class="filter-item">
          <label for="record-type">記錄類型</label>
          <select id="record-type" [(ngModel)]="filterOptions.recordType">
            <option value="all">全部記錄</option>
            <option value="in">入庫</option>
            <option value="out">出庫</option>
            <option value="transfer">轉移</option>
          </select>
        </div>
      </div>
      <div class="filter-row">
        <div class="filter-item">
          <label for="date-from">日期從</label>
          <input type="date" id="date-from" [(ngModel)]="filterOptions.dateFrom">
        </div>
        <div class="filter-item">
          <label for="date-to">日期至</label>
          <input type="date" id="date-to" [(ngModel)]="filterOptions.dateTo">
        </div>
        <!-- 添加搜尋按鈕 -->
        <div class="filter-item search-button-container">
          <button class="search-btn" (click)="applyFilters()">
            <i class="fas fa-search"></i> 搜尋
          </button>
          <button class="clear-btn" (click)="resetFilters()">
            <i class="fas fa-times"></i> 重置
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 載入指示器 -->
  <div class="loading-indicator" *ngIf="loading">
    <div class="spinner"></div>
    <span>載入中...</span>
  </div>

  <!-- 主內容區 -->
  <div class="use-list-content" *ngIf="!loading">
    <!-- 庫存信息 -->
    <div class="inventory-section">
      <div class="section-header">
        <h3>庫存概況</h3>
        <div class="action-buttons">
          <button class="action-btn add-btn" (click)="openRecordModal('in')">
            <i class="fas fa-plus"></i> 入庫
          </button>
          <button class="action-btn subtract-btn" (click)="openRecordModal('out')">
            <i class="fas fa-minus"></i> 出庫
          </button>
          <button class="action-btn transfer-btn" (click)="openRecordModal('transfer')">
            <i class="fas fa-exchange-alt"></i> 轉移
          </button>
        </div>
      </div>

      <table class="inventory-table">
        <thead>
          <tr>
            <th *ngIf="viewMode === 'chemical'">部門</th>
            <th *ngIf="viewMode === 'department'">化學品</th>
            <th>料號</th>
            <th>危險等級</th>
            <th>目前庫存</th>
            <th>最後更新</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let stock of filteredStocks">
            <td *ngIf="viewMode === 'chemical'">{{ stock.departmentName }}</td>
            <td *ngIf="viewMode === 'department'">{{ stock.chemicalName }}</td>
            <td>{{ stock.partNumber }}</td>
            <td>
              <div class="danger-level-indicator" [ngClass]="getDangerLevelClass(stock.dangerLevel)">
                {{ stock.dangerLevel === 3 ? '高' : (stock.dangerLevel === 2 ? '中' : '低') }}
              </div>
            </td>
            <td>
              <div class="stock-amount" [ngClass]="getStockStatusClass(stock)">
                {{ stock.currentStock }} {{ stock.unit }}
              </div>
            </td>
            <td>{{ stock.lastUpdated }}</td>
            <td class="action-cell">
              <div class="stock-actions">
                <button class="btn-sm" (click)="openRecordModal('in', stock.chemicalId)">
                  <i class="fas fa-plus"></i>
                </button>
                <button class="btn-sm" (click)="openRecordModal('out', stock.chemicalId)">
                  <i class="fas fa-minus"></i>
                </button>
                <button class="btn-sm" (click)="openRecordModal('transfer', stock.chemicalId)">
                  <i class="fas fa-exchange-alt"></i>
                </button>
                <button class="btn-sm history-btn" (click)="viewChemicalHistory(stock.chemicalId, stock.departmentId)">
                  <i class="fas fa-history"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="filteredStocks.length === 0">
            <td colspan="7" class="no-data">沒有符合條件的庫存資料</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 使用記錄 -->
    <div class="usage-records-section">
      <h3>使用記錄</h3>

      <table class="records-table">
        <thead>
          <tr>
            <th>日期</th>
            <th>化學品</th>
            <th>部門</th>
            <th>數量變更</th>
            <th>部門庫存</th>
            <th>備註</th>
            <th>操作人員</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of filteredRecords">
            <td>{{ record.date }}</td>
            <td>{{ record.chemicalName }}</td>
            <td>{{ record.departmentName }}</td>
            <td [class.record-positive]="record.quantity > 0" [class.record-negative]="record.quantity < 0">
              {{ record.quantity > 0 ? '+' : '' }}{{ record.quantity }} {{ record.unit }}
            </td>
            <td>{{ record.stockAfterChange }} {{ record.unit }}</td>
            <td>{{ record.note }}</td>
            <td>{{ record.recordedBy }}</td>
          </tr>
          <tr *ngIf="filteredRecords.length === 0">
            <td colspan="7" class="no-data">沒有符合條件的使用記錄</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- 操作記錄模態框 -->
  <div class="modal-overlay" *ngIf="showRecordModal">
    <div class="modal-container">
      <div class="modal-header">
        <h3>
          <span *ngIf="operationType === 'in'">化學品入庫</span>
          <span *ngIf="operationType === 'out'">化學品出庫</span>
          <span *ngIf="operationType === 'transfer'">化學品部門間轉移</span>
        </h3>
        <button class="close-btn" (click)="closeRecordModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="result-message" *ngIf="operationResult" [class.success]="operationResult.success" [class.error]="!operationResult.success">
          {{ operationResult.message }}
        </div>

        <div class="form-group">
          <label for="chemical-select">選擇化學品 <span class="required">*</span></label>
          <select id="chemical-select" [(ngModel)]="newRecord.chemicalId" required>
            <option value="">-- 請選擇化學品 --</option>
            <option *ngFor="let chem of chemicals" [value]="chem.id">
              {{ chem.chineseName }} ({{ chem.partNumber }})
            </option>
          </select>
        </div>

        <div class="form-group" *ngIf="operationType !== 'in'">
          <label for="source-department">來源部門 <span class="required">*</span></label>
          <select id="source-department" [(ngModel)]="newRecord.departmentId" required>
            <option value="">-- 請選擇部門 --</option>
            <option *ngFor="let dept of departments" [value]="dept.id">
              {{ dept.name }}
            </option>
          </select>
        </div>

        <div class="form-group" *ngIf="operationType === 'in' || operationType === 'transfer'">
          <label for="target-department">
            {{ operationType === 'in' ? '接收部門' : '目標部門' }}
            <span class="required">*</span>
          </label>
          <select id="target-department" [(ngModel)]="targetDepartmentId" (ngModelChange)="onTargetDepartmentChange($event)" required>
            <option value="">-- 請選擇部門 --</option>
            <option *ngFor="let dept of departments" [value]="dept.id"
              [disabled]="operationType === 'transfer' && dept.id === newRecord.departmentId">
              {{ dept.name }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="quantity">數量 <span class="required">*</span></label>
            <input type="number" id="quantity" [(ngModel)]="newRecord.quantity" min="0.1" step="0.1" required>
          </div>

          <div class="form-group">
            <label for="record-date">日期</label>
            <input type="date" id="record-date" [(ngModel)]="newRecord.date">
          </div>
        </div>

        <div class="form-group">
          <label for="note">備註說明</label>
          <textarea id="note" [(ngModel)]="newRecord.note" placeholder="請輸入備註說明"></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button class="cancel-btn" (click)="closeRecordModal()">取消</button>
        <button class="submit-btn" (click)="submitRecord()">確認</button>
      </div>
    </div>
  </div>

  <!-- 化學品歷程模態框 -->
  <div class="modal-overlay" *ngIf="showHistoryModal">
    <div class="modal-container history-modal">
      <div class="modal-header">
        <h3>「{{ selectedChemicalName }}」使用歷程 - {{ selectedDepartmentName }}</h3>
        <button class="close-btn" (click)="closeHistoryModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <!-- 歷程圖表 -->
        <div class="history-chart-container">
          <div class="chart-options">
            <div class="chart-period-selector">
              <button [class.active]="historyChartPeriod === '1m'" (click)="setHistoryChartPeriod('1m')">近1個月</button>
              <button [class.active]="historyChartPeriod === '3m'" (click)="setHistoryChartPeriod('3m')">近3個月</button>
              <button [class.active]="historyChartPeriod === '6m'" (click)="setHistoryChartPeriod('6m')">近6個月</button>
              <button [class.active]="historyChartPeriod === '1y'" (click)="setHistoryChartPeriod('1y')">近1年</button>
            </div>
          </div>

          <!-- ECharts 圖表容器 -->
          <div class="echart-container">
            <div id="historyChart" class="echart-element"></div>
          </div>
        </div>

        <!-- 歷程記錄表格 -->
        <div class="history-records">
          <h4>詳細記錄</h4>
          <table class="history-records-table">
            <thead>
              <tr>
                <th>日期</th>
                <th>操作類型</th>
                <th>數量變更</th>
                <th>庫存狀態</th>
                <th>操作人員</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of chemicalHistoryRecords">
                <td>{{ record.date }}</td>
                <td>
                  <span [class.record-in]="record.quantity > 0"
                        [class.record-out]="record.quantity < 0"
                        [class.record-transfer]="record.note.includes('轉移')">
                    {{ record.quantity > 0 ? '入庫' : (record.note.includes('轉移') ? '轉移' : '出庫') }}
                  </span>
                </td>
                <td [class.record-positive]="record.quantity > 0" [class.record-negative]="record.quantity < 0">
                  {{ record.quantity > 0 ? '+' : '' }}{{ record.quantity }} {{ record.unit }}
                </td>
                <td>{{ record.stockAfterChange }} {{ record.unit }}</td>
                <td>{{ record.recordedBy }}</td>
                <td>{{ record.note }}</td>
              </tr>
              <tr *ngIf="chemicalHistoryRecords.length === 0">
                <td colspan="6" class="no-data">沒有找到使用記錄</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 庫存統計信息 -->
        <div class="history-statistics">
          <h4>庫存統計</h4>
          <div class="statistics-cards">
            <div class="stat-card">
              <div class="stat-title">平均使用量</div>
              <div class="stat-value">{{ selectedChemicalStats.avgUsage }} {{ selectedChemicalStats.unit }}/月</div>
            </div>
            <div class="stat-card">
              <div class="stat-title">最大使用量</div>
              <div class="stat-value">{{ selectedChemicalStats.maxUsage }} {{ selectedChemicalStats.unit }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-title">平均儲存量</div>
              <div class="stat-value">{{ selectedChemicalStats.avgStock }} {{ selectedChemicalStats.unit }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-title">最大儲存量</div>
              <div class="stat-value">{{ selectedChemicalStats.maxStock }} {{ selectedChemicalStats.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
